import React, { useEffect, useRef } from 'react';
import imgTop from '../images/3page2.jpg';
import imgBottom from '../images/3page1.jpg';
import './Experience1.css';

export default function Experience() {
  const textRef = useRef(null);

  useEffect(() => {
    const el = textRef.current;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.remove('animate-in');
          void el.offsetWidth;
          el.classList.add('animate-in');
        }
      },
      { threshold: 0.5 }
    );

    if (el) observer.observe(el);

    return () => {
      if (el) observer.unobserve(el);
    };
  }, []);

  return (
    <section className="experience-page" id="experience">
      <div className="experience-content">
        <div className="exp-text" ref={textRef}>
          <h4>Experiences</h4>
          <h2>We Provide You The<br />Best Experience</h2>
          <p>
            Step into our world of fine craftsmanship, where every detail is
            carefully considered. At Jooloo, we create interiors that speak of
            elegance, comfort, and durability — designed to make your spaces
            truly unforgettable.
          </p>
          <p>
            To feel it, visit <a href="https://maps.app.goo.gl/y48PZJpbh68rnb7p8" target="_blank" rel="noreferrer">
              our experience center
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25" height="20" width="20">
                <path d="m17.5 5.999-.707.707 5.293 5.293H1v1h21.086l-5.294 5.295.707.707L24 12.499l-6.5-6.5z" data-name="Right" />
              </svg>
            </a>
          </p>
        </div>

        <div className="exp-images">
          <img src={imgBottom} alt="Experience bottom" className="exp-img img-bottom box-shadow" />
          <img src={imgTop} alt="Experience top" className="exp-img img-top box-shadow" />
        </div>
      </div>
    </section>
  );
}
